const CURVES = [
  { key: "sine",   glyph: "∿" },
  { key: "tri",    glyph: "∧" },
  { key: "square", glyph: "⊓" },
  { key: "saw",    glyph: "╱" },
];

export function createCurvePicker({ value, onChange }) {
  const row = document.createElement("div");
  row.className = "curve-row";
  row.setAttribute("role", "radiogroup");

  for (const c of CURVES) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "curve-btn";
    btn.dataset.curve = c.key;
    btn.setAttribute("aria-pressed", String(c.key === value));
    btn.textContent = c.glyph;
    btn.addEventListener("click", () => {
      for (const b of row.querySelectorAll(".curve-btn")) {
        b.setAttribute("aria-pressed", String(b === btn));
      }
      onChange?.(c.key);
    });
    row.appendChild(btn);
  }
  return { el: row };
}
